import React from 'react';
import PropTypes from 'prop-types';
import SearchBreadcrumbsDesktop from '../breadcrumbs/SearchBreadcrumbsDesktop';
import SpotListAvailabilityDesktop from '../spot-list/SpotListAvailabilityDesktop';

const AddressFeatureDesktop = ({
    breadcrumbs,
    isFetchComplete,
    numSpots
}) => {
    return (
        <div className="AddressFeature">
            <div className="detail">
                <SearchBreadcrumbsDesktop data={breadcrumbs} />
                <SpotListAvailabilityDesktop
                    isFetchComplete={isFetchComplete}
                    numSpots={numSpots}
                />
            </div>
        </div>
    );
};

AddressFeatureDesktop.propTypes = {
    breadcrumbs: PropTypes.object.isRequired,
    isFetchComplete: PropTypes.bool.isRequired,
    numSpots: PropTypes.number.isRequired
};

export default AddressFeatureDesktop;
